import React from "react";
import { withI18n } from "react-i18next";
import { client } from "../../../shared/apiClient";

import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { iRootState } from "../../../store";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "../../../Theme/custom-toast.css";
import { ISessionMaterial } from "../../../interfaces/ISessionMaterial";
import SendSessionMaterialModal from "../../Modals/SendSessionMaterialModal";
import { IKioskSessionInfo } from "../../../interfaces/IKioskSessionInfo";
import { ISentSessionMaterial } from "../../../interfaces/ISentSessionMaterial";
import { getEncodeParams } from "../../../helpers";

interface IState {
  scheduleId: string;
  isLoading: boolean;
  tmpMaterials: ISessionMaterial[];
}

const tempSessionMaterials: ISessionMaterial[] = [
  { firstName: "", lastName: "", email: "", displayOrder: 1 },
  { firstName: "", lastName: "", email: "", displayOrder: 2 },
  { firstName: "", lastName: "", email: "", displayOrder: 3 },
  { firstName: "", lastName: "", email: "", displayOrder: 4 },
  { firstName: "", lastName: "", email: "", displayOrder: 5 },
];

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  history: any;
  match: any;
  scheduleId: any;
  epitchId?: any;
  onCancel: () => void;
  showModal: boolean;
}

class SessionMaterial extends React.Component<IProps, IState> {
  public state: IState = {
    scheduleId: "",
    isLoading: false,
    tmpMaterials: JSON.parse(JSON.stringify(
      tempSessionMaterials
    )) as ISessionMaterial[]
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      const {
        scheduleId,
        epitchId,
        getSessionMaterials,
        getSentSessionMaterials,
        getKioskSessionInfo
      } = this.props;

      await getSessionMaterials(scheduleId);

      if (epitchId > 0) await getSentSessionMaterials(epitchId);

      if (
        this.props.sessionMaterials &&
        this.props.sessionMaterials.length > 0
      ) {
        this.setState({ tmpMaterials: this.props.sessionMaterials }, () => {
          this.setTmpMaterials();
        });
      }

      await getKioskSessionInfo(scheduleId);

      this.setState({ isLoading: false });
    } catch (error) {
      this.props.history.push("/500");
    }
  }

  componentDidUpdate = (prevProps: IProps) => {
    const { sessionMaterials } = this.props;
    const oldMats = JSON.stringify(prevProps.sessionMaterials);
    const newMats = JSON.stringify(sessionMaterials);

    if (oldMats !== newMats) {
      const newTmpMaterials = this.state.tmpMaterials.map((mat, index) => {
        if (mat.sessionMaterialId) {
          return sessionMaterials.find(m => m.sessionMaterialId === mat.sessionMaterialId);
        }

        if (mat.email) {
          return sessionMaterials.find(m => m.email === mat.email);
        }

        return mat;
      });

      this.setState({ tmpMaterials: newTmpMaterials }, () => {
        this.setTmpMaterials();
      });
    }
  };

  setTmpMaterials = () => {
    if (this.state.tmpMaterials.length >= tempSessionMaterials.length) return;

    let materials = this.state.tmpMaterials.map(mat => ({ ...mat }));

    for (
      let index = this.state.tmpMaterials.length;
      index < tempSessionMaterials.length;
      index++
    ) {
      materials.push({ ...tempSessionMaterials[index] });
    }

    this.setState({ tmpMaterials: materials });
  };

  onModalClose = () => {
    this.props.onCancel();
  };

  onChangeMaterial = async (e: any, sessionMaterial: any) => {
    if (!e || !sessionMaterial) return;
    const name = e.target.name;
    sessionMaterial[name] = e.target.value;
    let arrSessionMaterial = this.state.tmpMaterials.map(
      (s: ISessionMaterial) => {
        if (
          (s.sessionMaterialId &&
            s.sessionMaterialId === sessionMaterial.sessionMaterialId) ||
          (s.displayOrder && s.displayOrder === sessionMaterial.displayOrder)
        )
          return sessionMaterial;
        return s;
      }
    );
    this.setState({ tmpMaterials: arrSessionMaterial });
  };

  onSave = async (e: any, o: ISessionMaterial) => {
    if (!e || !o || (!o.sessionMaterialId && o.email.length <= 0)) return;

    const { sessionInfo, scheduleId } = this.props;

    let existing: any = this.props.sessionMaterials.find(
      (x) => x.scheduleId === scheduleId && x.email === o.email
    );

    if (existing) return;
    o.bdType = sessionInfo.bdType;
    o.breakdownId = sessionInfo.breakdownId;
    o.scheduleId = scheduleId;
    this.props.addSessionMaterial(o);
  };

  onBlurSave = async (e: any, o: ISessionMaterial) => {
    if (!e || !o || (!o.sessionMaterialId && o.email.length <= 0)) return;

    const { sessionInfo, scheduleId } = this.props;

    let existing: any = this.props.sessionMaterials.find(
      (x) => x.sessionMaterialId === o.sessionMaterialId
    );

    if (!existing) {
      const mat = { ...o };
      mat.bdType = sessionInfo.bdType;
      mat.breakdownId = sessionInfo.breakdownId;
      mat.scheduleId = scheduleId;
      await this.props.addSessionMaterial(mat);
      return;
    }

    const name = e.target.name;
    existing[name] = e.target.value;

    // Email input was deleted
    if (!existing.email && !existing.firstName && !existing.lastName) {
      await this.onDeleteRow(existing);
    } else {
      this.props.updateSessionMaterial(existing);
    }
  };

  onAddRow = () => {
    let materials = this.state.tmpMaterials.map(mat => ({ ...mat }));

    materials.push({
      firstName: "",
      lastName: "",
      email: "",
      displayOrder: materials.length + 1,
    });

    this.setState({ tmpMaterials: materials });
  };

  onDeleteRow = async (sessionMaterial: ISessionMaterial) => {
    if (!sessionMaterial || !sessionMaterial.sessionMaterialId) return;
    const { deleteSessionMaterial } = this.props;

    await deleteSessionMaterial(sessionMaterial.sessionMaterialId);

    const newTmpMaterials = this.state.tmpMaterials.map((mat, index) => {
      if (
        mat.sessionMaterialId &&
        mat.sessionMaterialId === sessionMaterial.sessionMaterialId
      ) {
        return { ...tempSessionMaterials[index] };
      }
      return mat;
    });
    this.setState({ tmpMaterials: newTmpMaterials })
  };

  onClickEdit = (o: ISessionMaterial) => {
    let materials = this.state.tmpMaterials.map(mat => ({ ...mat }));
    if (materials.length <= 0) return;
    let m = materials.find((x) => x.sessionMaterialId === o.sessionMaterialId);
    if (!m) return;
    m.isEditable = true;
    this.setState({ tmpMaterials: materials });
  };

  onCreateEpitch = async (e: any) => {
    if (e) e.preventDefault();
    const { scheduleId, sessionInfo } = this.props;
    const project = sessionInfo.projectName;
    const schedName = sessionInfo.scheduleName;

    // cases user input to submit click
    for (const sessionMaterial of this.state.tmpMaterials) {
      if (sessionMaterial.email && sessionMaterial.email.length > 0) {
        //&& isEmail(sessionMaterial.email))
        let existing: any = this.props.sessionMaterials.find(
          (x) =>
            x.scheduleId === sessionMaterial.scheduleId &&
            x.email === sessionMaterial.email
        );
        if (!existing) await this.onSave(e, sessionMaterial);
      }
    }

    if (schedName && project) {
      const title = `${schedName} - ${project}`;
      const params = {
        scheduleId: scheduleId,
        send: true,
        title: title, // title changed to be the last parameter due to special characters
      };
      const url = `${client.api.paths.epitch}/Manage/?${getEncodeParams(
        params
      )}`;
      window.location.href = url;
    }
  };

  render() {
    const { showModal } = this.props;

    return (
      <>
        {showModal && (
          <SendSessionMaterialModal
            show={showModal}
            handleChange={this.onChangeMaterial}
            isReadOnly={false}
            onCancel={this.onModalClose}
            onConfirm={this.onCreateEpitch}
            sessionMaterials={this.state.tmpMaterials}
            sentSessionMaterials={this.props.sentSessionMaterials}
            onBlurSave={this.onBlurSave}
            isLoading={this.state.isLoading}
            addRow={this.onAddRow}
            onDelete={this.onDeleteRow}
            onClickEdit={this.onClickEdit}
          />
        )}
      </>
    );
  }
}

interface StateProps {
  sessionMaterials: ISessionMaterial[];
  sentSessionMaterials: ISentSessionMaterial[];
  sessionInfo: IKioskSessionInfo;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessionMaterials: state.sessionMaterial.sessionMaterials,
    sentSessionMaterials: state.sentSessionMaterial.sentSessionMaterials,
    sessionInfo: state.kiosk.sessionInfo,
  };
}

interface DispatchProps {
  getSessionMaterials: (id: any) => void;
  getSentSessionMaterials: (id: any) => void;
  addSessionMaterial: (sessionMaterial: ISessionMaterial) => void;
  updateSessionMaterial: (sessionMaterial: ISessionMaterial) => void;
  getKioskSessionInfo: (id: any) => void;
  deleteSessionMaterial: (id: number) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getSessionMaterials: dispatch.sessionMaterial.getSessionMaterials,
    getSentSessionMaterials:
      dispatch.sentSessionMaterial.getSentSessionMaterials,
    addSessionMaterial: dispatch.sessionMaterial.addSessionMaterial,
    updateSessionMaterial: dispatch.sessionMaterial.updateSessionMaterial,
    getKioskSessionInfo: dispatch.kiosk.getKioskSessionInfo,
    deleteSessionMaterial: dispatch.sessionMaterial.deleteSessionMaterial,
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SessionMaterial))
);
